import { Component, inject, signal } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { DialogComponentI } from '@core/user-interface-legacy';
import {
  DialogBodyComponent,
  DialogHeaderComponent,
  DialogRef,
  NewItemButtonComponent,
} from '@core/user-interface-legacy';

type DialogData = {
  jobsCount: number;
};
type DialogResult = {
  enable: boolean;
};

@Component({
  selector: 'rt-manage-referrals-dialog',
  templateUrl: './manage-referrals-dialog.component.html',
  imports: [DialogHeaderComponent, DialogBodyComponent, NewItemButtonComponent, TranslatePipe],
})
export class ManageReferralsDialogComponent implements DialogComponentI<DialogData, DialogResult> {
  private readonly dialogRef = inject(DialogRef);

  protected jobsCount = signal(0);

  public setDialogData(data: DialogData): void {
    this.jobsCount.set(data.jobsCount || 1);
  }

  protected enable() {
    this.dialogRef.close({ enable: true });
  }

  protected disable() {
    this.dialogRef.close({ enable: false });
  }
}
